<template>
    <div class="Partner">
        <layout>
            <template slot="content">
                <div class="partnerBox">
                    <div class="partnerItem">
                        <h3 class="partnerTitle">百货零售</h3>
                        <img src="@/assets/images/partner/retail.png" class="contentImg"/>
                    </div>
                    <div class="partnerItem">
                        <h3 class="partnerTitle">餐饮行业</h3>
                        <img src="@/assets/images/partner/food.png" class="contentImg"/>
                    </div>
                    <div class="partnerItem">
                        <h3 class="partnerTitle">生活服务</h3>
                        <img src="@/assets/images/partner/service.png" class="contentImg"/>
                    </div>
                    <div class="partnerItem">
                        <h3 class="partnerTitle">酒店景区</h3>
                        <img src="@/assets/images/partner/hotel.png" class="contentImg"/>
                    </div>
                    <div class="partnerItem">
                        <h3 class="partnerTitle">娱乐行业</h3>
                        <img src="@/assets/images/partner/recreation.png" class="contentImg"/>
                    </div>
                    <div class="partnerItem">
                        <h3 class="partnerTitle">医疗行业</h3>
                        <img src="@/assets/images/partner/medical.png" class="contentImg"/>
                    </div>
                    <div class="partnerItem">
                        <h3 class="partnerTitle">烘焙行业</h3>
                        <img src="@/assets/images/partner/bake.png" class="contentImg"/>
                    </div>
                    <div class="partnerItem">
                        <h3 class="partnerTitle">加油站</h3>
                        <img src="@/assets/images/partner/petrolStation.png" class="contentImg"/>
                    </div>
                    <div class="partnerItem">
                        <h3 class="partnerTitle">房地产</h3>
                        <img src="@/assets/images/partner/realEstate.png" class="contentImg"/>
                    </div>
                </div>
                
            </template>
        </layout>
    </div>
</template>

<script>
import Layout from '@/components/Layout/index.vue'
export default {
    name:'Partner',
    components: {
        Layout
    },
    props:{},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {},
}
</script>
<style scoped>
.contentImg{
    max-width: 100%;
    float: left;
}
.partnerBox{
    width: 1100px;
    margin: 0 auto;
    margin-bottom: 60px;
}
.partnerItem{
    overflow: hidden;
}
.partnerTitle{
    margin: 40px 0 20px 0;
    font-weight: 500;
    padding-left: 20px;
    border-left: 5px solid #ff8118;
    text-align: left;
}
</style>